const getDurationFields = (
  seconds?: number | null,
): { durationHours: string; durationMinutes: string } => {
  if (seconds === null || seconds === undefined) return { durationHours: '', durationMinutes: '' };
  const totalMinutes = Math.ceil(seconds / 60);
  return {
    durationHours: String(Math.floor(totalMinutes / 60)),
    durationMinutes: String(totalMinutes % 60),
  };
};

export default getDurationFields;
